/*
 * Forge Maestro
 * (c) Honeywell
 */

var BANNER_KEYBOARD_VALUES;
(function (BANNER_KEYBOARD_VALUES) {
    BANNER_KEYBOARD_VALUES["ESCAPE"] = "Escape";
    BANNER_KEYBOARD_VALUES["ENTER"] = "Enter";
    BANNER_KEYBOARD_VALUES["SPACE"] = "Space";
})(BANNER_KEYBOARD_VALUES || (BANNER_KEYBOARD_VALUES = {}));

export { BANNER_KEYBOARD_VALUES };
//# sourceMappingURL=BannerProps.interface.js.map
